import React, { useState, useEffect } from 'react'
import './Toast.css'

let toastId = 0

const Toast = ({ message, type = 'info', duration = 3000, onClose, actions = [] }) => {
  useEffect(() => {
    if (actions.length > 0) return // Don't auto-close if there are actions

    const timer = setTimeout(() => {
      onClose()
    }, duration)

    return () => clearTimeout(timer)
  }, [duration, onClose, actions])

  return (
    <div className={`toast toast-${type}`}>
      <div className="toast-content">
        <span className="toast-message">{message}</span>
        {actions.length > 0 && (
          <div className="toast-actions">
            {actions.map((action, index) => (
              <button
                key={index}
                className={`toast-action-btn ${action.primary ? 'primary' : ''}`}
                onClick={() => {
                  action.onClick()
                  onClose()
                }}
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
      <button className="toast-close" onClick={onClose}>
        ×
      </button>
    </div>
  )
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState([])

  const addToast = (message, type = 'info', duration = 3000, options = {}) => {
    const id = toastId++
    const newToast = { id, message, type, duration, ...options }

    setToasts(prevToasts => [...prevToasts, newToast])

    return id
  }

  const removeToast = (id) => {
    setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id))
  }

  // Make addToast and removeToast globally available
  window.showToast = addToast
  window.dismissToast = removeToast

  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={() => removeToast(toast.id)}
          actions={toast.actions}
        />
      ))}
    </div>
  )
}

// Export convenience functions
export const showToast = (message, type = 'info', duration = 3000, options = {}) => {
  if (window.showToast) {
    return window.showToast(message, type, duration, options)
  }
}

export const showSuccess = (message, duration = 3000) => showToast(message, 'success', duration)
export const showError = (message, duration = 4000) => showToast(message, 'error', duration)
export const showInfo = (message, duration = 3000) => showToast(message, 'info', duration)